import { ReactComponent as Downarrow } from '../icons/caret-down-solid.svg';
import './uploadnews.css'

export default function Uploadnews() {
  return (
        <div className='news-post'>
            <div className='news-postimg'>
                <img src='https://besthqwallpapers.com/Uploads/19-8-2018/62142/thumb2-chris-pratt-hollywood-star-american-actor-photoshoot-portrait.jpg' alt='userimg' />
            </div>
            <div className='news-postinput'>
                <input type='text' placeholder="What's on your mind, User?"/>
                <Downarrow />
            </div>
            <button>Post</button>
        </div>
  )
}
